import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import Autosuggest from 'react-autosuggest';
import uniqBy from 'lodash/uniqBy';
import { subscribe } from 'react-contextual';
import getConfig from 'next/config';
import Star from '../../components/chrome/elements/icons/star';
import DataFetcher from '../../util/dataFetcher';
import SelectByPlatform from '../../components/workplace/common/selectByPlatform';
import axios from 'axios';

const config = getConfig().publicRuntimeConfig;
let tags = [];
let tagsMap = {};
const tagsTypeWeights = {
	cause: 1,
	'sub-cause': 2,
	location: 3,
	ngo: 5
};

const recommendedCause = [
	'The Akshaya Patra Foundation',
	'Goonj',
	'HelpAge India',
	'Girl Child',
	'Cancer'
];

const getSuggestions = value => {
	const popularTags = tags.filter(tag => tag.type.indexOf('cause') === 0);

	const inputValue = value.trim().toLowerCase();
	const inputLength = inputValue.length;

	if (inputLength === 0) {
		return [];
	}

	const startsWithMatches = tags
		.filter(tag => tag.value.toLowerCase().startsWith(inputValue))
		.sort(
			(a, b) =>
				tagsTypeWeights[a.type] * a.value.length -
				tagsTypeWeights[b.type] * b.value.length
		);

	const includesMatches = tags
		.filter(tag => tag.value.toLowerCase().includes(inputValue))
		.sort(
			(a, b) =>
				tagsTypeWeights[a.type] * a.value.length -
				tagsTypeWeights[b.type] * b.value.length
		);
	const causeMatchesArray = [];
	const ngoMatchesArray = [];
	const locationMatchesArray = [];
	const programMatchesArray = [];
	const categoriesMatchesArray = [];

	const usableMatches = startsWithMatches.concat(includesMatches.slice(0, 5));

	const matchesToShow = [];
	const matchSeen = {};

	for (let i = 0; i < usableMatches.length; i++) {
		let value = usableMatches[i].value.toLowerCase();

		if (!matchSeen[value]) {
			matchesToShow.push(usableMatches[i]);
			matchSeen[value] = true;
		}
	}

	for (let i = 0; i < matchesToShow.length; i++) {
		if (
			matchesToShow[i].type === 'cause' ||
			matchesToShow[i].type === 'sub-cause' ||
			matchesToShow[i].type === 'tag1' ||
			matchesToShow[i].type === 'tag2'
		)
			causeMatchesArray.push(matchesToShow[i]);
		else if (matchesToShow[i].type === 'ngo')
			ngoMatchesArray.push(matchesToShow[i]);
		else if (matchesToShow[i].type === 'location')
			locationMatchesArray.push(matchesToShow[i]);
		else if (matchesToShow[i].type === 'program')
			programMatchesArray.push(matchesToShow[i]);
		else categoriesMatchesArray.push(matchesToShow[i]);
	}
	const suggestionsArray = [];
	if (causeMatchesArray.length > 0)
		suggestionsArray.push({ title: 'Cause', suggestions: causeMatchesArray });
	if (ngoMatchesArray.length > 0)
		suggestionsArray.push({ title: 'NGO', suggestions: ngoMatchesArray });
	if (locationMatchesArray.length > 0)
		suggestionsArray.push({
			title: 'Location',
			suggestions: locationMatchesArray
		});
	if (programMatchesArray.length > 0)
		suggestionsArray.push({
			title: 'Programs',
			suggestions: programMatchesArray
		});
	if (categoriesMatchesArray.length > 0)
		suggestionsArray.push({
			title: 'Categories',
			suggestions: categoriesMatchesArray
		});
	if (matchesToShow.length === 0)
		suggestionsArray.push({
			title: "Oops! We couldn't find any results. Try these...",
			suggestions: popularTags
		});
	return suggestionsArray
		.map(section => ({
			title: section.title,
			suggestions: section.suggestions.filter(suggestion => suggestion.value)
		}))
		.filter(section => section.suggestions.length > 0);
};

const getSuggestionValue = suggestion => suggestion.value;

const renderSuggestion = suggestion => <div>{suggestion.value}</div>;

const renderSectionTitle = section => (
	<div>
		<span style={{ fontSize: '0.75rem' }}> &nbsp; {section.title} </span>
	</div>
);

const getSectionSuggestions = section => section.suggestions;

class QuickSearch extends React.Component {
	constructor(props) {
		super(props);
		const urlTags = [];

		this.state = {
			value: '',
			suggestions: [],
			searchTags: []
		};
	}

	componentDidMount = async () => {
		try {
			const searchTags = await DataFetcher.getAllSearchTags();
			this.setState({
				searchTags
			});
			tags = uniqBy(searchTags.tags, 'tag');
			for (let it = 0; it < tags.length; it++) {
				if (tags[it].tag !== undefined && tags[it].tag !== 'undefined') {
					if (!tagsMap[tags[it].tag]) {
						tagsMap[tags[it].tag] = tags[it];
					}
				}
			}
		} catch (err) {
			console.log('error while fetching searchTags', err);
		}
	};

	redirectToCampaign = () => {
		window.location.href = '/campaign/mission-10-million-meals';
	};

	onSuggestionsFetchRequested = ({ value }) => {
		this.setState({
			suggestions: getSuggestions(value)
		});
	};

	onSuggestionSelected = (event, { suggestion }) => {
		this.updateUrl([suggestion], 'relevance');
	};

	updateUrl = (tags, type) => {
		let search = '';

		if (tags && tags.length > 0) {
			let terms = [];

			for (let i = 0; i < tags.length; i++) {
				terms.push(tags[i].value);
			}

			search += 'tag=' + encodeURIComponent(terms.join('|'));
		}

		if (type) {
			if (search.length > 0) {
				search += '&';
			}

			search += `type=${type}`;
		}
		window.location.href = `/search?${search}`;
	};

	onRecommendedTagSelected = (event, obj) => {
		this.onSuggestionSelected(event, { suggestion: obj });
	};

	renderInputComponent = inputProps => (
		<div className="new-input-container">
			<img
				src={`${config.cdnUrl}/static/icons/search.svg`}
				className="new-icon"
			/>
			<input {...inputProps} />
		</div>
	);

	onChange = (event, { newValue }) => {
		this.setState({
			value: newValue
		});
	};

	handleTagClick = (e, val) => {
		window.location.href = `/search?tag=${val}`;
	};

	render() {
		const { tenantConfig, placeholder, hideRecommendations } = this.props;
		const inputProps = {
			placeholder: placeholder,
			value: this.state.value,
			onChange: this.onChange,
			// autoFocus: true
			// onFocus: this.showRecommendationBox,
		};

		const tenantRecommendedCause =
			tenantConfig && tenantConfig.search
				? tenantConfig.search.recommendedCause
				: recommendedCause;
		return (
			<div
				className="search-box-quicksearch d-flex f-d-col"
				id="searchBox-container"
			>
				<Col xs={12} sm={12} md={12} lg={12} style={{ padding: '0px' }}>
					<Autosuggest
						className="search-box w-100"
						multiSection
						suggestions={this.state.suggestions}
						onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
						getSuggestionValue={getSuggestionValue}
						renderSuggestion={renderSuggestion}
						renderSectionTitle={renderSectionTitle}
						getSectionSuggestions={getSectionSuggestions}
						inputProps={inputProps}
						onSuggestionSelected={this.onSuggestionSelected}
						highlightFirstSuggestion
						renderInputComponent={this.renderInputComponent}
					/>
				</Col>
				{!hideRecommendations && (<Col className="d-flex col-md-12 my-2 pl-0">
					{
						(tenantRecommendedCause).map((item, idx) => {
							return (
								<div key={idx} className="recommandation-box-quickSearch" onClick={(e) => this.handleTagClick(e, item)}>
									{item}
								</div>
							)
						})
					}
				</Col>)}
			</div>
		);
	}
}

export default subscribe()(QuickSearch);
